(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[492],{

/***/ 7484:
/***/ (function(module) {

!function(t,e){ true?module.exports=e():0}(this,(function(){"use strict";var t=1e3,e=6e4,n=36e5,r="millisecond",i="second",s="minute",u="hour",a="day",o="week",f="month",h="quarter",c="year",d="date",l="Invalid Date",$=/^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/,y=/\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,M={name:"en",weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),ordinal:function(t){var e=["th","st","nd","rd"],n=t%100;return"["+t+(e[(n-20)%10]||e[n]||e[0])+"]"}},m=function(t,e,n){var r=String(t);return!r||r.length>=e?t:""+Array(e+1-r.length).join(n)+t},v={s:m,z:function(t){var e=-t.utcOffset(),n=Math.abs(e),r=Math.floor(n/60),i=n%60;return(e<=0?"+":"-")+m(r,2,"0")+":"+m(i,2,"0")},m:function t(e,n){if(e.date()<n.date())return-t(n,e);var r=12*(n.year()-e.year())+(n.month()-e.month()),i=e.clone().add(r,f),s=n-i<0,u=e.clone().add(r+(s?-1:1),f);return+(-(r+(n-i)/(s?i-u:u-i))||0)},a:function(t){return t<0?Math.ceil(t)||0:Math.floor(t)},p:function(t){return{M:f,y:c,w:o,d:a,D:d,h:u,m:s,s:i,ms:r,Q:h}[t]||String(t||"").toLowerCase().replace(/s$/,"")},u:function(t){return void 0===t}},g="en",D={};D[g]=M;var p=function(t){return t instanceof _},S=function t(e,n,r){var i;if(!e)return g;if("string"==typeof e){var s=e.toLowerCase();D[s]&&(i=s),n&&(D[s]=n,i=s);var u=e.split("-");if(!i&&u.length>1)return t(u[0])}else{var a=e.name;D[a]=e,i=a}return!r&&i&&(g=i),i||!r&&g},w=function(t,e){if(p(t))return t.clone();var n="object"==typeof e?e:{};return n.date=t,n.args=arguments,new _(n)},O=v;O.l=S,O.i=p,O.w=function(t,e){return w(t,{locale:e.$L,utc:e.$u,x:e.$x,$offset:e.$offset})};var _=function(){function M(t){this.$L=S(t.locale,null,!0),this.parse(t)}var m=M.prototype;return m.parse=function(t){this.$d=function(t){var e=t.date,n=t.utc;if(null===e)return new Date(NaN);if(O.u(e))return new Date;if(e instanceof Date)return new Date(e);if("string"==typeof e&&!/Z$/i.test(e)){var r=e.match($);if(r){var i=r[2]-1||0,s=(r[7]||"0").substring(0,3);return n?new Date(Date.UTC(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)):new Date(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)}}return new Date(e)}(t),this.$x=t.x||{},this.init()},m.init=function(){var t=this.$d;this.$y=t.getFullYear(),this.$M=t.getMonth(),this.$D=t.getDate(),this.$W=t.getDay(),this.$H=t.getHours(),this.$m=t.getMinutes(),this.$s=t.getSeconds(),this.$ms=t.getMilliseconds()},m.$utils=function(){return O},m.isValid=function(){return!(this.$d.toString()===l)},m.isSame=function(t,e){var n=w(t);return this.startOf(e)<=n&&n<=this.endOf(e)},m.isAfter=function(t,e){return w(t)<this.startOf(e)},m.isBefore=function(t,e){return this.endOf(e)<w(t)},m.$g=function(t,e,n){return O.u(t)?this[e]:this.set(n,t)},m.unix=function(){return Math.floor(this.valueOf()/1e3)},m.valueOf=function(){return this.$d.getTime()},m.startOf=function(t,e){var n=this,r=!!O.u(e)||e,h=O.p(t),l=function(t,e){var i=O.w(n.$u?Date.UTC(n.$y,e,t):new Date(n.$y,e,t),n);return r?i:i.endOf(a)},$=function(t,e){return O.w(n.toDate()[t].apply(n.toDate("s"),(r?[0,0,0,0]:[23,59,59,999]).slice(e)),n)},y=this.$W,M=this.$M,m=this.$D,v="set"+(this.$u?"UTC":"");switch(h){case c:return r?l(1,0):l(31,11);case f:return r?l(1,M):l(0,M+1);case o:var g=this.$locale().weekStart||0,D=(y<g?y+7:y)-g;return l(r?m-D:m+(6-D),M);case a:case d:return $(v+"Hours",0);case u:return $(v+"Minutes",1);case s:return $(v+"Seconds",2);case i:return $(v+"Milliseconds",3);default:return this.clone()}},m.endOf=function(t){return this.startOf(t,!1)},m.$set=function(t,e){var n,o=O.p(t),h="set"+(this.$u?"UTC":""),l=(n={},n[a]=h+"Date",n[d]=h+"Date",n[f]=h+"Month",n[c]=h+"FullYear",n[u]=h+"Hours",n[s]=h+"Minutes",n[i]=h+"Seconds",n[r]=h+"Milliseconds",n)[o],$=o===a?this.$D+(e-this.$W):e;if(o===f||o===c){var y=this.clone().set(d,1);y.$d[l]($),y.init(),this.$d=y.set(d,Math.min(this.$D,y.daysInMonth())).$d}else l&&this.$d[l]($);return this.init(),this},m.set=function(t,e){return this.clone().$set(t,e)},m.get=function(t){return this[O.p(t)]()},m.add=function(r,h){var d,l=this;r=Number(r);var $=O.p(h),y=function(t){var e=w(l);return O.w(e.date(e.date()+Math.round(t*r)),l)};if($===f)return this.set(f,this.$M+r);if($===c)return this.set(c,this.$y+r);if($===a)return y(1);if($===o)return y(7);var M=(d={},d[s]=e,d[u]=n,d[i]=t,d)[$]||1,m=this.$d.getTime()+r*M;return O.w(m,this)},m.subtract=function(t,e){return this.add(-1*t,e)},m.format=function(t){var e=this,n=this.$locale();if(!this.isValid())return n.invalidDate||l;var r=t||"YYYY-MM-DDTHH:mm:ssZ",i=O.z(this),s=this.$H,u=this.$m,a=this.$M,o=n.weekdays,f=n.months,h=function(t,n,i,s){return t&&(t[n]||t(e,r))||i[n].slice(0,s)},c=function(t){return O.s(s%12||12,t,"0")},d=n.meridiem||function(t,e,n){var r=t<12?"AM":"PM";return n?r.toLowerCase():r},$={YY:String(this.$y).slice(-2),YYYY:this.$y,M:a+1,MM:O.s(a+1,2,"0"),MMM:h(n.monthsShort,a,f,3),MMMM:h(f,a),D:this.$D,DD:O.s(this.$D,2,"0"),d:String(this.$W),dd:h(n.weekdaysMin,this.$W,o,2),ddd:h(n.weekdaysShort,this.$W,o,3),dddd:o[this.$W],H:String(s),HH:O.s(s,2,"0"),h:c(1),hh:c(2),a:d(s,u,!0),A:d(s,u,!1),m:String(u),mm:O.s(u,2,"0"),s:String(this.$s),ss:O.s(this.$s,2,"0"),SSS:O.s(this.$ms,3,"0"),Z:i};return r.replace(y,(function(t,e){return e||$[t]||i.replace(":","")}))},m.utcOffset=function(){return 15*-Math.round(this.$d.getTimezoneOffset()/15)},m.diff=function(r,d,l){var $,y=O.p(d),M=w(r),m=(M.utcOffset()-this.utcOffset())*e,v=this-M,g=O.m(this,M);return g=($={},$[c]=g/12,$[f]=g,$[h]=g/3,$[o]=(v-m)/6048e5,$[a]=(v-m)/864e5,$[u]=v/n,$[s]=v/e,$[i]=v/t,$)[y]||v,l?g:O.a(g)},m.daysInMonth=function(){return this.endOf(f).$D},m.$locale=function(){return D[this.$L]},m.locale=function(t,e){if(!t)return this.$L;var n=this.clone(),r=S(t,e,!0);return r&&(n.$L=r),n},m.clone=function(){return O.w(this.$d,this)},m.toDate=function(){return new Date(this.valueOf())},m.toJSON=function(){return this.isValid()?this.toISOString():null},m.toISOString=function(){return this.$d.toISOString()},m.toString=function(){return this.$d.toUTCString()},M}(),T=_.prototype;return w.prototype=T,[["$ms",r],["$s",i],["$m",s],["$H",u],["$W",a],["$M",f],["$y",c],["$D",d]].forEach((function(t){T[t[1]]=function(e){return this.$g(e,t[0],t[1])}})),w.extend=function(t,e){return t.$i||(t(e,_,w),t.$i=!0),w},w.locale=S,w.isDayjs=p,w.unix=function(t){return w(1e3*t)},w.en=D[g],w.Ls=D,w.p={},w}));

/***/ }),

/***/ 9937:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/[slug]",
      function () {
        return __webpack_require__(2385);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 3517:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "v": function() { return /* binding */ config; },
  "r": function() { return /* binding */ configSet; }
});

;// CONCATENATED MODULE: ./public/logo.png
/* harmony default export */ var logo = ({"src":"/_next/static/media/logo.ad9b92b2.png","height":512,"width":512,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAY1BMVEVMaXFCgbsQRIZOd6F2gFtCkMW/pioFQpEAEzYiVYFKZWfywQ+ckD0qaZw3frI0eKwydaksbaAAMG5sjauguNCVrcV5nLx6mbU6ZJaimlJQamhgcl+Dg0dTbWNNoNf///+jl0Ief3V8AAAAHnRSTlMA/VRj9vr8Mw5uef75sNz5/tZahNr+u7k9/mL09ewQFWwFAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAQklEQVR4nB3GRxKAIBAAwSEpLCjmnP7/Si371IBHN7kFM/bhcg6me+hUXcEyGx88bKJFAOyj1qIE9mjjnzMdyX55AVwDAnzXIZPiAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./lib/pageConfig.js

// eslint-disable-next-line import/prefer-default-export
const config = {
    siteName: "Dr.Doc AI",
    blogTitle: "Blog",
    baseUrl: "drdoc.ai",
    websiteLogo: logo,
    twitterHandle: "@junaid_builds",
    twitterCardType: "Dr.Doc AI Blog",
    css: {
        primaryColor: "#111",
        accentColor: "#455A64",
        lightGray: "#eeeeee",
        backgroundColor: "#fff",
        black: "#111",
        white: "#fff",
        textColor: "#333",
        opacity: 0.7
    }
};
const privacy = {
    ...config,
    siteDescription: "Privacy policy for AI Doctor Documentation Tool ",
    defaultPageTitle: "Privacy | Dr.Doc AI"
};
const FAQ = {
    ...config,
    siteDescription: "Frequently asked questions for Dr.Doc AI",
    defaultPageTitle: "FAQ | Dr.Doc AI"
};
const landing = {
    ...config,
    siteDescription: "Dr.Doc AI will quickly transcribe and format your appointment notes with your exact format - in seconds.",
    defaultPageTitle: "AI Clinical Documentation | Dr.Doc AI "
};
const thankYou = {
    ...config,
    siteDescription: "Dr.Doc AI will quickly transcribe and format your appointment notes with your exact format - in seconds.",
    defaultPageTitle: "Get In Touch | Dr.Doc AI"
};
const blogHome = {
    ...config,
    siteDescription: "Dr.Doc AI will quickly transcribe and format your appointment notes with your exact format - in seconds.",
    defaultPageTitle: "Blog | Dr.Doc AI"
};
const configSet = {
    FAQ,
    privacy,
    landing,
    blogHome,
    thankYou
};


/***/ }),

/***/ 2385:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Blog; }
});

// NAMESPACE OBJECT: ./node_modules/@mdx-js/react/index.js
var _mdx_js_react_namespaceObject = {};
__webpack_require__.r(_mdx_js_react_namespaceObject);
__webpack_require__.d(_mdx_js_react_namespaceObject, {
  "MDXContext": function() { return MDXContext; },
  "MDXProvider": function() { return MDXProvider; },
  "useMDXComponents": function() { return useMDXComponents; },
  "withMDXComponents": function() { return withMDXComponents; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next-mdx-remote/dist/jsx-runtime.cjs
var dist_jsx_runtime = __webpack_require__(2746);
;// CONCATENATED MODULE: ./node_modules/@mdx-js/react/lib/index.js
/**
 * @typedef {import('react').ReactNode} ReactNode
 * @typedef {import('mdx/types').MDXComponents} Components
 *
 * @typedef Props
 *   Configuration.
 * @property {Components} [components]
 *   Mapping of names for JSX components to React components.
 * @property {boolean} [disableParentContext=false]
 *   Turn off outer component context.
 * @property {ReactNode} [children]
 *   Children.
 *
 * @callback MergeComponents
 * @param {Components} currentComponents
 *   Current components from the context.
 * @returns {Components}
 *   Merged components.
 */



/**
 * @type {import('react').Context<Components>}
 * @deprecated
 *   This export is marked as a legacy feature.
 *   That means it’s no longer recommended for use as it might be removed
 *   in a future major release.
 *
 *   Please use `useMDXComponents` to get context based components and
 *   `MDXProvider` to set context based components instead.
 */
const MDXContext = react.createContext({})

/**
 * @param {import('react').ComponentType<any>} Component
 * @deprecated
 *   This export is marked as a legacy feature.
 *   That means it’s no longer recommended for use as it might be removed
 *   in a future major release.
 *
 *   Please use `useMDXComponents` to get context based components instead.
 */
function withMDXComponents(Component) {
  return boundMDXComponent

  /**
   * @param {Record<string, unknown> & {components?: Components}} props
   * @returns {JSX.Element}
   */
  function boundMDXComponent(props) {
    const allComponents = useMDXComponents(props.components)
    return react.createElement(Component, {...props, allComponents})
  }
}

/**
 * Get current components from the MDX Context.
 *
 * @param {Components|MergeComponents} [components]
 *   Additional components to use or a function that takes the current
 *   components and filters/merges/changes them.
 * @returns {Components}
 *   Current components.
 */
function useMDXComponents(components) {
  const contextComponents = react.useContext(MDXContext)
  // Memoize to avoid unnecessary top-level context changes
  return react.useMemo(() => {
    // Custom merge via a function prop
    if (typeof components === 'function') {
      return components(contextComponents)
    }

    return {...contextComponents, ...components}
  }, [contextComponents, components])
}

/** @type {Components} */
const emptyObject = {}

/**
 * Provider for MDX context
 *
 * @param {Props} props
 * @returns {JSX.Element}
 */
function MDXProvider({components, children, disableParentContext}) {
  let allComponents = useMDXComponents(components)

  if (disableParentContext) {
    allComponents = components || emptyObject
  }

  return react.createElement(
    MDXContext.Provider,
    {value: allComponents},
    children
  )
}

;// CONCATENATED MODULE: ./node_modules/@mdx-js/react/index.js


;// CONCATENATED MODULE: ./node_modules/next-mdx-remote/dist/index.js




if (typeof window !== 'undefined') {
  window.requestIdleCallback =
    window.requestIdleCallback ||
    function (cb) {
      var start = Date.now();
      return setTimeout(function () {
        cb({
          didTimeout: false,
          timeRemaining: function () {
            return Math.max(0, 50 - (Date.now() - start))
          },
        });
      }, 1)
    };

  window.cancelIdleCallback =
    window.cancelIdleCallback ||
    function (id) {
      clearTimeout(id);
    };
}

/**
 * Renders compiled source from next-mdx-remote/serialize.
 */
function MDXRemote({ compiledSource, frontmatter, scope, components = {}, lazy, }) {
    const [isReadyToRender, setIsReadyToRender] = (0,react.useState)(!lazy || typeof window === 'undefined');
    // if we're on the client side and `lazy` is set to true, we hydrate the
    // mdx content inside requestIdleCallback, allowing the page to get to
    // interactive quicker, but the mdx content to hydrate slower.
    (0,react.useEffect)(() => {
        if (lazy) {
            const handle = window.requestIdleCallback(() => {
                setIsReadyToRender(true);
            });
            return () => window.cancelIdleCallback(handle);
        }
    }, []);
    const Content = (0,react.useMemo)(() => {
        // if we're ready to render, we can assemble the component tree and let React do its thing
        // first we set up the scope which has to include the mdx custom
        // create element function as well as any components we're using
        const fullScope = Object.assign({ opts: { ..._mdx_js_react_namespaceObject, ...dist_jsx_runtime/* jsxRuntime */.c } }, { frontmatter }, scope);
        const keys = Object.keys(fullScope);
        const values = Object.values(fullScope);
        // now we eval the source code using a function constructor
        // in order for this to work we need to have React, the mdx createElement,
        // and all our components in scope for the function, which is the case here
        // we pass the names (via keys) in as the function's args, and execute the
        // function with the actual values.
        const hydrateFn = Reflect.construct(Function, keys.concat(`${compiledSource}`));
        return hydrateFn.apply(hydrateFn, values).default;
    }, [scope, compiledSource]);
    if (!isReadyToRender) {
        // If we're not ready to render, return an empty div to preserve SSR'd markup
        return (react.createElement("div", { dangerouslySetInnerHTML: { __html: '' }, suppressHydrationWarning: true }));
    }
    // wrapping the content with MDXProvider will allow us to customize the standard
    // markdown components (such as "h1" or "a") with the "components" object
    const content = (react.createElement(MDXProvider, { components: components },
        react.createElement(Content, null)));
    // If lazy = true, we need to render a wrapping div to preserve the same markup structure that was SSR'd
    return lazy ? react.createElement("div", null, content) : content;
}



// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./utils/seo.js
var seo = __webpack_require__(3298);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(7484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
;// CONCATENATED MODULE: ./utils/formatters.js

function formatSEODate(dateString) {
    let dateModified = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if (!dateString && dateModified) {
        return "";
    }
    return dateString ? new Date(dateString).toISOString() : new Date().toISOString();
}
function formatTime(seconds) {
    return dayjs(seconds).format("mm:ss:SSS");
}
function formatDisplayDate(dateString) {
    return dayjs_min_default()(dateString).format("MMMM DD, YYYY");
}
function getSecondsSinceEpoch(dateString) {
    return new Date(dateString).getTime() / 1000;
}

;// CONCATENATED MODULE: ./components/blog/blogMeta.jsx





const BlogMeta = (param)=>{
    let { meta  } = param;
    const router = (0,next_router.useRouter)();
    if (!meta) {
        console.error("meta not found!");
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: "Not found"
        });
    }
    const formattedPublishDate = formatSEODate(meta.publishDate);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "px-4",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                ...(0,seo/* createSEOConfig */.WQ)(meta)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(seo/* BlogSeo */.JV, {
                data: meta
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
                className: "flex flex-col",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: meta.imageUrl,
                        className: "my-4"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        className: "mt-6 text-4xl font-bold tracking-tight text-zinc-800 sm:text-5xl",
                        children: meta.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("time", {
                        dateTime: meta.date,
                        className: "order-first flex items-center justify-between text-base text-zinc-400 ",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                type: "button",
                                onClick: ()=>router.back(),
                                "aria-label": "Go back to articles",
                                className: "group flex h-10 w-10 items-center justify-center rounded-full bg-white shadow-lg shadow-zinc-800/6 ring-1 ring-zinc-900/5 transition",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowLeftIcon, {
                                    className: "h-4 w-4 stroke-pink-600 transition group-hover:stroke-zinc-700 "
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "h-4 w-0.5 rounded-full bg-zinc-200 "
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "ml-3",
                                        children: [
                                            " ",
                                            formatDisplayDate(formattedPublishDate),
                                            " •",
                                            " ",
                                            meta.readingTime.text
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            meta.tag && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "text-drDocBlue text-sm",
                children: meta.tag.toUpperCase()
            })
        ]
    });
};
function ArrowLeftIcon(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        viewBox: "0 0 16 16",
        fill: "none",
        "aria-hidden": "true",
        ...props,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M7.25 11.25 3.75 8m0 0 3.5-3.25M3.75 8h8.5",
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
}
/* harmony default export */ var blogMeta = (BlogMeta);

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./components/blog/dls/anchor.jsx


// import { OutboundLink } from "react-ga";
const Anchor = (props)=>{
    const { href  } = props;
    const isInternalLink = href && (href.startsWith("/") || href.startsWith("#"));
    if (isInternalLink) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: href,
            passHref: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                textDecoration: "underline",
                ...props
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
        // as={OutboundLink}
        to: href,
        textDecoration: "underline",
        isExternal: true,
        ...props
    });
};
/* harmony default export */ var dls_anchor = (Anchor);

;// CONCATENATED MODULE: ./components/blog/convertKitForm.jsx


const ConvertKitForm = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "bg-white max-w-2xl mx-auto",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "mx-auto max-w-7xl py-12 px-4 md:py-16",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                    className: "text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "block",
                            children: "Ready to Start?"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "block text-drDocBlue",
                            children: "Start using Dr.Doc AI for Free."
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mt-8 flex",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "inline-flex",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dls_anchor, {
                                href: "/blog",
                                className: "text-center items-center justify-center w-full my-4 border border-drDocBlue text-drDocBlue hover:bg-purple-50 rounded-lg py-3 flex flex-row px-4 gap-2",
                                children: [
                                    "Explore Blogs",
                                    " "
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "ml-3 inline-flex",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://client.drdoc.ai/register",
                                target: "_blank",
                                rel: "noreferrer",
                                className: "w-max border border-gray-800 hover:text-gray-900 my-4 rounded-md px-4 py-3 bg-gray-900 text-white hover:bg-white",
                                children: "Get Access - 2mins"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var convertKitForm = (ConvertKitForm);

;// CONCATENATED MODULE: ./components/blog/layout.jsx



const Layout = (param)=>{
    let { children , frontMatter  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-16 lg:mt-32",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "xl:relative",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mx-auto max-w-2xl",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(blogMeta, {
                                    meta: frontMatter
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "prose mt-8 px-4",
                                    children: children
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(convertKitForm, {})
        ]
    });
};
/* harmony default export */ var layout = (Layout);

;// CONCATENATED MODULE: ./components/blog/figure.jsx

const Figure = (param)=>/*#__PURE__*/ {
    let { src , alt , caption =""  } = param;
    return (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: src,
                alt: alt
            }),
            caption && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: caption
            })
        ]
    });
};
/* harmony default export */ var figure = (Figure);

;// CONCATENATED MODULE: ./components/blog/mdxComponents.jsx





const Hr = ()=>{
    const { colorMode  } = useColorMode();
    const borderColor = {
        light: "gray.200",
        dark: "gray.600"
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        borderColor: borderColor[colorMode],
        my: 4,
        w: "100%"
    });
};
const components = {
    h1: (props)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
            as: "h1",
            size: "xl",
            my: 4,
            ...props
        }),
    h2: (props)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
            as: "h2",
            size: "lg",
            my: 4,
            ...props
        }),
    h3: (props)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
            as: "h3",
            size: "md",
            my: 4,
            ...props
        }),
    p: (props)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
            as: "p",
            mt: 4,
            lineHeight: "tall",
            ...props
        }),
    ul: (props)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
            as: "ul",
            pt: 2,
            pl: 4,
            ml: 2,
            ...props
        }),
    ol: (props)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("ol", {
            as: "ol",
            pt: 2,
            pl: 4,
            ml: 2,
            ...props
        }),
    li: (props)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
            as: "li",
            pb: 1,
            ...props
        }),
    a: dls_anchor,
    Anchor: (props)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            as: "li",
            pb: 1,
            ...props
        }),
    hr: Hr,
    OutboundAnchor: dls_anchor,
    inlineCode: (props)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            ...props,
            colorScheme: "red"
        }),
    BlogMeta: blogMeta,
    ConvertkitForm: convertKitForm,
    Figure: figure
};
/* harmony default export */ var mdxComponents = (components);

// EXTERNAL MODULE: ./components/container/base.jsx + 3 modules
var base = __webpack_require__(5216);
;// CONCATENATED MODULE: ./pages/blog/[slug].js





var __N_SSG = true;
function Blog(param, props) {
    let { mdxSource , frontMatter  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(base/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(layout, {
            frontMatter: frontMatter,
            ...props,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MDXRemote, {
                ...mdxSource,
                components: mdxComponents
            })
        })
    });
}


/***/ }),

/***/ 3298:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cd": function() { return /* binding */ createSEOPageConfig; },
/* harmony export */   "JV": function() { return /* binding */ BlogSeo; },
/* harmony export */   "WQ": function() { return /* binding */ createSEOConfig; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2962);
/* harmony import */ var _lib_pageConfig__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3517);



const getImage = function() {
    let data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (data.imageUrl) {
        return [
            {
                url: data.imageUrl,
                width: 600,
                height: 300,
                alt: data.title
            }
        ];
    }
    if (data.slug) {
        return [
            {
                url: "/api/blog-image/".concat(data.slug),
                width: 600,
                height: 300,
                alt: data.title
            }
        ];
    }
    return [
        {
            url: _lib_pageConfig__WEBPACK_IMPORTED_MODULE_2__/* .config.websiteLogo */ .v.websiteLogo,
            width: 280,
            height: 280,
            alt: "JRO"
        }
    ];
};
function BlogSeo(param) {
    let { data  } = param;
    if (!data) return null;
    const description = data.seoDescription ? data.seoDescription : _lib_pageConfig__WEBPACK_IMPORTED_MODULE_2__/* .config.siteDescription */ .v.siteDescription;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .ArticleJsonLd */ .dX, {
        url: data.canonicalUrl,
        title: data.title,
        images: getImage(data).map((file)=>file.url),
        datePublished: data.publishDate,
        dateModified: data.modifiedDate,
        authorName: _lib_pageConfig__WEBPACK_IMPORTED_MODULE_2__/* .config.author */ .v.author,
        publisherName: _lib_pageConfig__WEBPACK_IMPORTED_MODULE_2__/* .config.author */ .v.author,
        publisherLogo: "https://www.example.com/photos/logo.jpg",
        description: description
    });
}
function createSEOConfig() {
    let data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const title = data.title || _lib_pageConfig__WEBPACK_IMPORTED_MODULE_2__/* .config.defaultPageTitle */ .v.defaultPageTitle;
    const description = data.seoDescription ? data.seoDescription : _lib_pageConfig__WEBPACK_IMPORTED_MODULE_2__/* .config.siteDescription */ .v.siteDescription;
    return {
        title,
        description,
        openGraph: {
            type: "website",
            locale: "en_US",
            url: data.canonicalUrl,
            title,
            description,
            images: getImage(data),
            site_name: _lib_pageConfig__WEBPACK_IMPORTED_MODULE_2__/* .config.siteName */ .v.siteName
        },
        twitter: {
            handle: _lib_pageConfig__WEBPACK_IMPORTED_MODULE_2__/* .config.twitterHandle */ .v.twitterHandle,
            site: _lib_pageConfig__WEBPACK_IMPORTED_MODULE_2__/* .config.twitterHandle */ .v.twitterHandle,
            cardType: _lib_pageConfig__WEBPACK_IMPORTED_MODULE_2__/* .config.twitterCardType */ .v.twitterCardType
        }
    };
}
function createSEOPageConfig() {
    let config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (!config) return null;
    const title = config.defaultPageTitle;
    const description = config.siteDescription;
    return {
        title,
        description,
        openGraph: {
            type: "website",
            locale: "en_US",
            url: config.canonicalUrl,
            title,
            description,
            images: getImage(config),
            site_name: config.siteName
        },
        twitter: {
            handle: config.twitterHandle,
            site: config.twitterHandle,
            cardType: config.twitterCardType
        }
    };
}


/***/ }),

/***/ 2746:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * Allow jsx-runtime to be successfully imported from either React 17 or React 18.
 *
 * Inspired by the approach here: https://github.com/contentlayerdev/contentlayer/blob/main/packages/next-contentlayer/src/hooks/jsx-runtime.cjs
 */
const jsxRuntime = __webpack_require__(5893)

module.exports.c = jsxRuntime


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [228,962,216,774,888,179], function() { return __webpack_exec__(9937); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);